import { PopupType } from '../../../components/popup/types';
import { CrossOriginCommunication } from '../../../controllers/crossOriginCommunication/CrossOriginCommunicationController';
import { gameStateActions } from '../../../store/slices/game/slice';
import { popupActions } from '../../../store/slices/popup/slice';
import { OutgoingMessage } from '../../crossOriginCommunication/types';
import { type GameCommunicationMessageType, MessageName } from '../types';

import { BaseCoreGameCommunicationProcessor } from './BaseCoreGameCommunicationProcessor';

export class CoreSessionExpireGameCommunicationProcessor extends BaseCoreGameCommunicationProcessor {
  public messageName = MessageName.DuplicatedConnection;

  public process(_message: GameCommunicationMessageType): void {
    CrossOriginCommunication.dispatch(OutgoingMessage.ErrorMessage, {
      errorCode: '8075',
      errorMessage: 'SESSION_EXPIRED_ERROR',
    });

    this.store.dispatch(popupActions.overwritePopup(PopupType.LoggedOut));
    this.store.dispatch(gameStateActions.setGameAbandoned(true));
  }
}
